<template>
    <div class="file-list">
        <div v-for="file in list"
             :key="file.id_file"
             class="d-flex file-element my-2"
        >
            <div class="flex-grow-1">
                {{ file.name }}
            </div>
            <div class="flex-grow-0">
                <btn v-if="action === 'delete'"
                     theme="none"
                     icon="trash-can-outline"
                     confirm="Soll diese Datei wirklich gelöscht werden?"
                     @click="handleDelete(file.id_file)"
                />
                <btn v-else-if="action === 'download'"
                     theme="none"
                     icon="download"
                     @click="handleDownload(file.id_file)"
                />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .file-element {
            border-bottom: 1px solid lightgray;
        }
</style>

<script>
    export default {
        props: {
            list: {type: Array, required: true},
            action: {type: String, required: true},
            confirmDelete: {type: Boolean, default: true},
        },

        methods: {
            async handleDownload(id_file) {
                let url = `/api/file/content/${btoa(id_file)}`;
                window.open(url, '_blank');
            },

            async handleDelete(id_file) {
                let data = await this.$store.dispatch('upload/delete', {id_file});

                if (data.$success) {
                    this.$emit('fileDeleted', id_file);
                }
            },
        },
    };
</script>